/** @jsx jsx */
import { jsx, Box, Flex } from 'theme-ui';

const ScrollableColumns = ({
  children,
  gap = 'medium',
  columnMinWidth,
  padding,
  backgroundColor,
  backgroundColorOverride,
}) => {
  return (
    <Box
      sx={{
        bg: backgroundColorOverride || backgroundColor,
        p: padding,
        width: '100%',
      }}
    >
      <Flex
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'nowrap',
          gap: gap,
          width: '100%',
          // Enable horizontal scroll when columns overflow
          // On desktop, if columns fit, they display normally without scrolling
          overflowX: 'auto',
          overflowY: 'hidden',
          // Hide scrollbar but keep scroll functionality for touch/swipe
          scrollbarWidth: 'none', // Firefox
          msOverflowStyle: 'none', // IE and Edge
          WebkitOverflowScrolling: 'touch', // Smooth scrolling on iOS
          '&::-webkit-scrollbar': {
            display: 'none', // Chrome, Safari, Opera
          },
          // Ensure columns maintain their width and don't shrink
          '& > *': {
            flexShrink: 0,
            minWidth: columnMinWidth || 'auto',
            // On desktop, if no minWidth specified, allow columns to grow equally
            // If minWidth is specified, columns maintain that width
            flex: columnMinWidth ? '0 0 auto' : '1 1 auto',
          },
        }}
      >
        {children}
      </Flex>
    </Box>
  );
};

export default ScrollableColumns;

